import { ApolloError, TypedDocumentNode, useApolloClient, useQuery } from '@apollo/client';
import { Interval, toDate } from 'date-fns';
import { gql } from 'graphql-tag';
import { FeedIn, FeedInMarketLocation, FeedInQuery, FeedInQueryVariables } from '../../generated/graphql';

const query: TypedDocumentNode<FeedInQuery, FeedInQueryVariables> = gql`
  query FeedIn($marketLocations: [FeedInMarketLocation!]!, $interval: IntervalInput!) {
    feedIn(marketLocations: $marketLocations, interval: $interval) {
      id
      marketLocationId
      interval {
        start
        end
      }
      values {
        date
        forecastedValue
        measuredValue
        msconsCode
      }
    }
  }
`;

export function useFeedIn(
  marketLocations: Array<FeedInMarketLocation>,
  interval: Interval,
): [readonly FeedIn[] | undefined, ApolloError | undefined] {
  const { data, error } = useQuery(query, {
    variables: {
      marketLocations,
      interval: {
        start: toDate(interval.start),
        end: toDate(interval.end),
      },
    },
    errorPolicy: 'all',
  });

  return [data?.feedIn, error];
}

export function useFeedInAsync(
  marketLocations: Array<FeedInMarketLocation>,
): (interval: Interval) => Promise<readonly FeedIn[]> {
  const client = useApolloClient();

  return async (interval) => {
    const response = await client.query({
      query,
      variables: {
        marketLocations,
        interval: {
          start: toDate(interval.start),
          end: toDate(interval.end),
        },
      },
    });
    return response.data.feedIn;
  };
}
